import { gql } from "@apollo/client";

export const getSiteCheckpointsQuery = gql`
query($siteId: String!){
  getSiteCheckpoints(siteId: $siteId) {
    message
    response
  }
}
`;

export const getSiteCheckpointByIdQuery = gql`
query($checkpointId: String!){
  getSiteCheckpointById(checkpointId: $checkpointId) {
    message
    response
  }
}
`;
